import Vue from 'vue';
export default Vue.extend({
    methods: {
        tableClassSetter(item) {
            return item.selected ? 'selected' : 'cursor-pointer';
        },
        handleRowClick(item) {
            item.selected = !item.selected;
        }
    }
});
